import VehicleLevel from '@/enums/VehicleLevel';
import VehicleType from '@/enums/VehicleType';
import PurchaseTime from '@/enums/PurchaseTime';
import VehicleCondition from '@/enums/VehicleCondition';
import CustomerType from '@/enums/CustomerType';
import Address from '../Address';
import IAddress from '../interfaces/IAddress';
import IEnquiry from '../interfaces/IEnquiry';
import IVehicleData from '../interfaces/IVehicleData';
import EnquiryBase from './EnquiryBase';
import OptInData from '../OptInData';
import IFinance from '../interfaces/IFinance';
import Finance from '../finance/Finance';
import IBusiness from '../interfaces/IBusiness';
import Business from '../business/Business';

export default class Enquiry extends EnquiryBase implements IEnquiry {
  public enquiryId: number = 0;

  public enquiryDate: Date = new Date();

  public formattedEnquiryType!: string;

  public vehicleData!: IVehicleData;

  public mailChimpSubscriberListId!: string;

  public cloakId!: string;

  public thanksPageUrl!: string;

  public derivativeId: number | null = null;

  public optInMarketing: boolean = false;

  public vehicleLevel!: VehicleLevel;

  public testDriveRequested: boolean = false;

  public quoteRequested: boolean = false;

  public brochureRequested: boolean = false;

  public digitalBrochureRequested: boolean = false;

  public motabilityRequested: boolean = false;

  public vehicleType!: VehicleType;

  public ipAddress!: string;

  public thanksPageContentId!: number;

  public thanksEmailTemplateName!: string;

  public manufacturerIds: number[] | null = null;

  public rangeIds: number[] | null = null;

  public queryStringValues!: any[];

  public privacyPolicyVersionId: string = '';

  public termsPolicyVersionId: string = '';

  public servicePolicyVersionId: string = '';

  public marketingPolicyVersionId: string = '';

  public partnerMarketingPolicyVersionId: string = '';

  public fCAPolicyVersionId: string = '';

  public purchaseTime: PurchaseTime = PurchaseTime.NotSpecified;

  public vehicleCondition: VehicleCondition = VehicleCondition.NotSet;

  public customerType: CustomerType = CustomerType.NotSet;

  public reCaptchaToken: string | null = null;

  public address: IAddress = new Address();

  public finance: IFinance = new Finance();

  public business: IBusiness = new Business();

  public optInData: OptInData[] | null = null;

  public notes: string | null = null;
}
